import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'LAUDO_CONTROLE_ITEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('laudoControleItemForm', registro)
    ];
}

export function getLista(idControle, idTipo) {
	return (dispatch, getState) => {

		dispatch({
			type: 'LAUDO_CONTROLE_ITEM_LISTADO',
		    payload: { data: [] }
		});

    	axios.get(`${consts.API_URL}/laudoControleItem?id_controle=${idControle}&id_tipo=${idTipo}`)
		.then(resp => {
			dispatch({
		        type: 'LAUDO_CONTROLE_ITEM_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaControle() {
	return (dispatch, getState) => {

		axios.get(`${consts.API_URL}/laudoControle`).then(resp => {
			dispatch({
				type: 'LAUDO_CONTROLE_LISTADO',
		        payload: resp
			});
		}).then(resp => {
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/laudoControleItem`, {
				...registro,
				data_vencimento: DateFormat.formatarDataTelaParaSql(registro.data_vencimento),
				data_realizacao: DateFormat.formatarDataTelaParaSql(registro.data_realizacao),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_controle, registro.id_tipo));
				dispatch(getListaControle());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/laudoControleItem`, {
				...registro,
				data_vencimento: DateFormat.formatarDataTelaParaSql(registro.data_vencimento),
				data_realizacao: DateFormat.formatarDataTelaParaSql(registro.data_realizacao),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_controle, registro.id_tipo));
				dispatch(getListaControle());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/laudoControleItem?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_controle, registro.id_tipo));
			dispatch(getListaControle());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
